import {ApplicationState} from "../../redux/AppStore";
import {connect} from "react-redux";
import StandardMap from "../../components/lib/StandardMap/StandardMap";
import React from 'react';
import {Dispatch} from "redux";
import {ILocatorMapState} from "../../redux/reducers/postshop-locator/locatorMapReducer";
import postshopServices from "../../services/postshopServices";
import {locatorMapActions} from "../../redux/actions/postshop-locator/locatorMapActions";
import GeolocationIcon from "../../components/lib/Icons/GeolocationIcon/GeolocationIcon";
import {selectLocationList, selectShouldAdjustMapExtentToLocations} from "./external";
import './LocatorMapContainer.scss';
import isEmpty from "lodash/isEmpty";
import filter from "lodash/filter";
import includes from "lodash/includes";

/**
 * Map properties from state to locator search component
 * @param state
 */
const mapStateToProps = (state: ApplicationState) => ({
  ...state.postshopLocator.mapState,
  locations: selectLocationList(state),
  shouldAdjustMapExtentToLocations: selectShouldAdjustMapExtentToLocations(state),
  selectedFilter: state.postshopLocator.selectedFilter
});

/**
 * Map all relevant functions to properties with dispatch events
 *
 * @param dispatch
 */
const mapDispatchToProps = (dispatch: Dispatch) => ({
  // FIXME: change value type to shareable Interface
  onMapExtentChange: (value: object) => dispatch(locatorMapActions.mapExtentChanged(value)),
});

export interface ILocatorMapProps extends ILocatorMapState {
  locations: Array<any>;
  onMapExtentChange: Function;
  shouldAdjustMapExtentToLocations: any;
  selectedFilter: any;
}

/**
 * Stateless higher order component for rendering a standard map for postshop locator purposes
 * @param props
 * @constructor
 */
const LocatorMap = (props: ILocatorMapProps) => {
  const {selectedFilter, locations} = props;
  const geoLocation = props.geo_latitude && props.geo_longitude;
  const onlyOneLocation = props.locations && props.locations.length === 1;
  const zoom = onlyOneLocation ? 14 : geoLocation ? 11 : props.zoom;

  // console.log('LocatorMap locations =', props.locations)
  // if (props.geo_latitude && props.geo_longitude) {
  //   const currentLocationIcon: IStandardMapIcon = {
  //     id: "geolocation",
  //     point: {latitude: props.geo_latitude, longitude: props.geo_longitude},
  //     createIconComponent: () => <GeolocationIcon/>,
  //     iconWidth: "40px",
  //     iconHeight: "40px"
  //   }
  // }

  //Filter if selectedFilter is not empty;
  let filteredResults = isEmpty(selectedFilter) ? locations : filter(locations, (location) => {
    return includes(location.services, selectedFilter);
  });

  const maxAmountResults = filteredResults.length > 50 ? 50 : filteredResults.length;

  filteredResults = filteredResults.slice(0, maxAmountResults);

  let mapIcons = postshopServices.buildPostshopLocationMapIcons(filteredResults);

  if (geoLocation) {
    // @ts-ignore
    mapIcons.push(<GeolocationIcon lat={props.geo_latitude} lng={props.geo_longitude} text="My current location" key={`mapIcon-geolocation`}/>);
  }

  // @ts-ignore
  return <StandardMap
    height="100vh"
    width="100%"
    center={{
      lat: props.geo_latitude ? props.geo_latitude : props.latitude,
      lng: props.geo_longitude? props.geo_longitude : props.longitude
    }}
    zoom={props.zoom}
    onMapExtentChange={props.onMapExtentChange}
    locations={filteredResults}
    shouldAdjustMapExtentToLocations={props.shouldAdjustMapExtentToLocations}
  >
    {mapIcons}
  </StandardMap>
}

const LocatorMapContainer = connect(mapStateToProps, mapDispatchToProps)(LocatorMap);

export default LocatorMapContainer;





// WEBPACK FOOTER //
// ./src/containers/postshop-locator/LocatorMapContainer.tsx